import gql from 'graphql-tag';

const QUERY = gql`
    query getPortalDashboardStats($operatorId: ID!) {
        portalDashboardStats(operatorId: $operatorId) {
            simulations,
            orders,
            transacted,
            totalTransacted,
            conversionRate,
            weightedMean
        }
    }
`;

export default QUERY;



// WEBPACK FOOTER //
// ./src/components/Pages/Dashboard/Header/query.js